import styled from 'styled-components/native';
import {
    Feather as IconsFE,
    FontAwesome5 as IconsFA5,
  } from "@expo/vector-icons";
import { themes } from '../../../design/colors';

export const Content = styled.ScrollView`
  flex: 1;
  padding: 16px 16px 0 16px;
`;

export const DataUser = styled.Text`
  font-size: 22px;
  color: ${themes.colors.gray3};
  font-weight: bold;
`;


export const TitleDataUser = styled.Text`
  font-size: 12px;
  color: ${themes.colors.gray4};
`;


export const ContentAvatar = styled.View`
  align-items: center;
`;

export const TextDeliveries = styled.Text`
  color: ${themes.colors.black};
  font-weight: bold;
  font-size: 22px;
  margin-top: 6px;
  margin-bottom: 12px;
`;

